export default {"src":"/_next/static/media/copy.20032b90.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};